module.exports = __webpack_public_path__ + "img/speak3.20038591.png";